import Vue from 'vue';
import * as GmapVue from 'gmap-vue'
import SiteHeader from '../vue/SiteHeader.vue';
import SiteFooter from '../vue/SiteFooter.vue';
import IntroBanner from '../vue/IntroBanner.vue';
import CallToActionContainer from '../vue/CallToActionContainer.vue';
import CallToAction from '../vue/CallToAction.vue';
import NewsListing from '../vue/NewsListing.vue';
import NewsListingItem from '../vue/NewsListingItem.vue';
import SubscribeBanner from '../vue/SubscribeBanner.vue';
import PageBanner from '../vue/PageBanner.vue';
import TeamMemberContainer from '../vue/TeamMemberContainer.vue';
import TeamMember from '../vue/TeamMember.vue';
import InternalBanner from '../vue/InternalBanner.vue';
import PostBanner from '../vue/PostBanner.vue';
import InquireForm from '../vue/InquireForm.vue';
import PostShare from '../vue/PostShare.vue';
import GoogleMap from '../vue/GoogleMap.vue';
import FaqList from '../vue/FaqList.vue';
import BrandGrid from '../vue/BrandGrid.vue';
import VideoModal from '../vue/VideoModal.vue';

Vue.use(GmapVue, {
  load: {
    key: 'AIzaSyBvBUEC0g_ZKO91GenI4B7XP-xkI9nNIvk',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then set installComponents to 'false'.
  //// If you want to automatically install all the components this property must be set to 'true':
  installComponents: true,
})

export default {
  init() {
    
    /* Vue
    ---------------------------------------------------------------------------------------------------- */
    
    Vue.config.productionTip = false;
    
    new Vue({
      data: {
        topScrollThreshold: 100,
        isScrolled: false,
      },
      
      components: {
        SiteHeader,
        SiteFooter,
        IntroBanner,
        CallToActionContainer,
        CallToAction,
        NewsListing,
        NewsListingItem,
        SubscribeBanner,
        PageBanner,
        TeamMemberContainer,
        TeamMember,
        InternalBanner,
        InquireForm,
        PostBanner,
        PostShare,
        GoogleMap,
        FaqList,
        BrandGrid,
        VideoModal,
      },
      
      methods: {
        didScroll () {
          this.isScrolled = (window.scrollY > this.topScrollThreshold);
        },
      },
      
      created () {
        window.addEventListener('scroll', this.didScroll);
      },
      
      destroyed () {
        window.removeEventListener('scroll', this.didScroll);
      },
      
      mounted () {
          
      },
      
    }).$mount('#app');
    

  },
  finalize() {
  
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js